import { render, staticRenderFns } from "./Science-projects.vue?vue&type=template&id=73cccc6a&scoped=true&"
import script from "./Science-projects.vue?vue&type=script&lang=js&"
export * from "./Science-projects.vue?vue&type=script&lang=js&"
import style0 from "./Science-projects.vue?vue&type=style&index=0&id=73cccc6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cccc6a",
  null
  
)

export default component.exports